import {TestRunStatus} from '../types.ts';

// ⚠️ ABANDONED MUST NEVER LOOK LIKE FAILED (FNP-969).
//
// This is the whole point of the Test Runs module:
//
//   FAILED    = the test RAN and did not pass  -> a defect in the PRODUCT
//   ABANDONED = the canary died mid-wake and the lease expired, so the sweep
//               closed the run out -> a defect in the HARNESS
//
// Reading an ABANDONED run as a failure reports a product defect that never
// happened, and sends someone hunting a bug that does not exist. The colours are
// therefore deliberately far apart (red vs grey) rather than adjacent shades, and
// each carries a description stating which of the two things it means. Do not
// "tidy" ABANDONED into the red family — tests/profile/TestRunStatusBadge.test.tsx
// fails if you do.
//
// Lives in its own module rather than beside the badge component so it can be
// imported by tests and by the legend without tripping react-refresh's
// only-export-components rule.
export const STATUS_CONFIG: Record<TestRunStatus, {
    color: string,
    label: string,
    description: string,
}> = {
    [TestRunStatus.RUNNING]: {
        color: 'blue',
        label: 'Running',
        description: 'In flight — the executor holds a lease and has not closed this run yet.',
    },
    [TestRunStatus.PASSED]: {
        color: 'green',
        label: 'Passed',
        description: 'The test ran and every step met its expected outcome.',
    },
    [TestRunStatus.FAILED]: {
        color: 'red',
        label: 'Failed',
        description: 'The test RAN and did not pass. This is a defect in the product under test.',
    },
    [TestRunStatus.ABANDONED]: {
        color: 'gray',
        label: 'Abandoned',
        description: 'NOT a failure. The canary died mid-wake and the lease expired, so the sweep closed this run out. This is a harness problem, not a product defect.',
    },
};
